<template>
    <div id="about-us-layout">
        <section id="about-section" class="light">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-11 ml-auto mr-auto">
                        <h1>
                            Truestock is made up of a team passionate about photography, good design and capturing everyday life as it happens. We love working with our diverse range of photographers.
                        </h1>
                    </div>
                </div>
            </div>
        </section>

        <section id="about-section-details" class="dark-bg">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-4 description-left">
                        Local life from a <br class="d-none d-lg-inline-block"/>local point of view
                    </div>
                    <div class="col-12 col-lg-8 description-right">
                        The images you see on Truestock are all exclusive to us. We work closely with our photographers to create unique content based on market insights. We have in-house art direction experts which assist our contributors
                        with custom briefs to generate content that's relevant and representative of an authentic and multicultural&nbsp;Australia.
                    </div>
                </div>
            </div>
        </section>

        <section id="profile-section" class="light">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-3">
                        <img src="https://aus-truestock-holding.s3.ap-southeast-2.amazonaws.com/tan-profile.jpg" alt="Tanmay Desai">
                        <div class="info">
                            <div><strong>Tanmay Desai</strong></div>
                            <div>CEO, Director</div>
                            <div>tan@truestock.com.au</div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-9">
                        <p>
                            An entrepreneur at heart with passion for the creative sector, I’ve been deeply involved with the creative industry for over 17 years. Working with various design agencies and organisations, my specialisation has
                            been across brand and identity&nbsp;work.
                            <br><br>
                            Being a Design Director I have been involved with not just graphic design but art directing multiple photoshoots for various businesses small and big. I’ve worked with many talented photographers, marketers and
                            producers on creating briefs, art directing sets and making sure teams can capture what's needed - on the day of the shoot! It's a skill set that helps me work well with our contributors and clients&nbsp;at&nbsp;Truestock.
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-3">
                        <img src="https://aus-truestock-holding.s3.ap-southeast-2.amazonaws.com/leah-profile.jpg" alt="Leah Desborough">
                        <div class="info">
                            <div><strong>Leah Desborough</strong></div>
                            <div>Contributor Management</div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-9">
                        <p>
                            My career launched with the introduction of Brisbane first Lifestyle magazine, the "Brisbane News" Magazine as Chief Photographer in 1994, followed by extensive experience in London working for "The Times" and
                            Mirror Group as Chief Photographer for the South London Press. My last position before coming home to Australia in 2010 was Picture Editor for 5 National Newspapers across the UK.
                            <br><br>
                            Immersed in the Photography Industry since days of film, I have an established business of my own, specialising in a large variety of high-end fields such as Corporate Portraiture, Personal and Business Branding,
                            Media and Marketing, Commercial Photography, Architecture and&nbsp;Interior&nbsp;Design.
                            <br><br>
                            I have also been a teacher in Photographic subjects for 12 years at Queensland TAFE and Torrens University where I specifically lecture on Business and Marketing, Media, Documentary and Visual&nbsp;Language&nbsp;of&nbsp;Photography.
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-3">
                        <img src="https://aus-truestock-holding.s3.ap-southeast-2.amazonaws.com/ovi-profile.jpg" alt="Ovidii Alexeenco">
                        <div class="info">
                            <div><strong>Ovidii Alexeenco</strong></div>
                            <div>CIO, Director</div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-9">
                        <p>
                            I am a Software Engineer with over a decade of experience designing, building and delivering world class software platforms to businesses and end users. I have worked with many businesses ranging from start-ups
                            to large corporates. During this time, I have experienced many aspects of software development, from hands on programming to
                            project and team management. This experience has instilled in me the discipline and knowledge to deliver the best possible solutions that focus on you, the user.
                            <br><br>
                            With Truestock, I am excited to have the opportunity to make a positive impact on the creative community and enhance how our members conduct their business.
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-3">
                        <img src="https://aus-truestock-holding.s3.ap-southeast-2.amazonaws.com/daniel-profile.jpg" alt="Daniel Leddy">
                        <div class="info">
                            <div><strong>Daniel Leddy</strong></div>
                            <div>Director <span class="smaller">CA, LLB (Hons), BCom, Dip CII</span></div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-9">
                        <p>
                            I have worked in finance and insurance for the past 17 years. I have had experience working in both small businesses and large multinational corporations, providing meaningful financial insight and leading
                            successful&nbsp;teams.
                            <br><br>
                            I am a chartered accountant, and combined with a law degree, I aim to provide a high level of financial and corporate&nbsp;governance.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: 'NzAbout'
}
</script>
